import { useId } from 'react'

import { CheckChipGroup } from '@/components/ui/CheckChipGroup'
import { ToggleField } from '@/components/ui/ToggleField'
import { CATEGORIES } from '@/data/categories'

interface DigestFieldsProps {
  optIn: boolean
  categories: string[]
  onOptInChange: (optIn: boolean) => void
  onCategoriesChange: (categories: string[]) => void
  disabled?: boolean
}

/**
 * The weekly-digest toggle and its category picker. Shared verbatim by the
 * `/welcome` step and the Stash preferences panel so the copy can't drift.
 */
export function DigestFields({
  optIn,
  categories,
  onOptInChange,
  onCategoriesChange,
  disabled,
}: DigestFieldsProps) {
  const toggleId = useId()

  return (
    <div className="space-y-6">
      <ToggleField
        id={toggleId}
        checked={optIn}
        onChange={(next) => {
          onOptInChange(next)
          if (!next) {
            onCategoriesChange([])
          }
        }}
        disabled={disabled}
        label="Email me a weekly digest of new links"
        description="The newest referral and discount links in the categories you choose. You can turn this off any time."
      />

      {optIn && (
        <CheckChipGroup
          legend="Which categories?"
          hint="Pick as many as you like."
          options={CATEGORIES}
          selected={categories}
          onChange={onCategoriesChange}
          disabled={disabled}
        />
      )}
    </div>
  )
}
